import AjaxService from "services/base/Ajax.service";

class AlertService extends AjaxService {
  async getAlerts() {
    return this.get("/alert/");
  }

  async getAllAlerts(includeDeleted = false) {
    return this.get(
      `/alert/all${includeDeleted ? "?includeDeleted=true" : ""}`,
    );
  }

  async upsertAlert(data) {
    return this.post("/alert/upsert", data);
  }

  async getAlert(alertId) {
    return this.get(`/alert/${alertId}`);
  }

  async dismissAlerts(data) {
    return this.post("/alert/dismiss/", data);
  }

  async deleteAlert(alertId) {
    return this.delete(`/alert/${alertId}`);
  }
}

export default new AlertService();
